//This file was created to apply Redux
import React, { useEffect, useState } from "react"

import HomeContainer from "../Container/HomeContainer2"
import TeacherProfile from "../Profile/TeacherProfile.redux"

// import { createUserObject } from "../Profile/profile.utils"
import Spinner from "../../Components/Spinner/Spinner"
// import { verifyUserRole } from "../../Helper";
import Auth from "../../Auth/Auth";
import { addCanDeliverAdmin } from "../../redux/homePage/homePage.actions";
import { connect } from "react-redux";
import { API } from "../../API";
import { notify } from "react-notify-toast";

// import ProfileBox from "../../Components/ProfileBox/ProfileBox";

const SharedProfile = (props) => {
  // const user = props.location.state
  const [user, setUser] = useState(null)
  // const user = props.sharedProfile;
  const role = Auth.verifyUserRole();
  // const userObject = createUserObject(user)
  const { addCanDeliverAdmin, sharedProfileTeacherID } = props

  const isViewAsCollege = (role === "customer" || role === "personnel")
  const isViewAsAdmin = (role === "admin")

  const [qualificationList, setQualificationList] = useState()
  const [selectedList, setSelectedList] = useState([])


  const handleQualification = (user) => {
    API.getQualificationList().then(result => {
      const qualifications = result?.data?.data
      setQualificationList(qualifications)
    })
  }

  const fetchProfileTeacher = async () => {
    try {
      const response = await API.getUserSafeDataById(sharedProfileTeacherID)
      setUser(response?.data?.user)
    } catch (error) {
      notify.show(error?.data?.response?.message)
    }
  }
  useEffect(() => {
    fetchProfileTeacher()
    handleQualification()
  }, [])

  if (user) {
    return (
      <HomeContainer
        isShared
        isViewAsTeacher={false}
        isViewAsCollege={isViewAsCollege}
        footer={null}
        isShowWhereby
        tabProfileActive
        user={user}
        isShowPoliceCheckWwcc={true}
      >
        {qualificationList && <TeacherProfile
          isShowFooter={false}
          user={user}
          setUser={setUser}
          // userObject={userObject}
          seeResume
          isShared
          isViewAsAdmin={isViewAsAdmin}
          // addCanDeliverAdmin={(user) => handleCanDeliversChange(user)}
          // selectedItem={selectedList}
          qualifications={qualificationList}
        />}
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

const mapStateToProps = (state) => {
  return {
    sharedProfileTeacherID: state?.user?.sharedProfileTeacherID,
  }
}

const mapDispatchToProps = (dispatch) => ({
  addCanDeliverAdmin: (user) => dispatch(addCanDeliverAdmin(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(SharedProfile)
